import * as React from 'react';
import {
    fetchBuyCalculationData,
    fetchCalculationData,
    fetchUpdateCalculationData
} from '../../../../epics/calculation-data';
import { connect } from 'react-redux';
import { PaymentTerms } from '../../../../types/enums/PaymentTerms';
import { CalculationOut } from '../../../../types/calculationData/products/companyCar/calculationOut';
import FirstStep from '../FirstStep/FirstStep';
import SecondStep from '../SecondStep/SecondStep';
import { fetchTemplateData } from '../../../../epics/get-template-data';
import * as moment from 'moment';
import { getText } from '../../../../services/text/text-service';
import {
    resolveChosenInsuranceName,
    resolveMileage,
    resolvePaymentTerm
} from '../../../../services/summary-page/companyCar';
import { calculatePrice } from '../../../../services/summary-page/common';
import { numberWithSpaces } from '../../../../utils/stringUtils';
import { MailingChannel } from '../../../../types/enums/mailingChannel';
import { updateCalculationData } from '../../../../actions/calculation-actions';
import { CompanyCarCalculationData } from '../../../../types/calculationData/products/companyCar/companyCarCalculationData';
import CompanyCarSummaryStep from '../SummaryStep/CompanyCarSummaryStep';
import { TillagsCoveragesIds } from '../../../../types/enums/products/companyCar/coverages';
import { ageResolver } from '../../../../services/customer/customer-service';
import {
    createUtagViewData,
    invokeUtagData
} from '../../../../utils/statisticsUtils';
import { StatsDataEnum } from '../../../../types/enums/statsDataEnum';
import { resolvePartnerForStats } from '../../../../services/stats/stats-service';
import Personnummer from 'personnummer';
import { cin } from 'swe-validation';
import { resolvePriceForPaymentTerm } from '../../../../services/calculation-data/calculation-data-service';
import {
    AGENT_PARAM,
    AGREEMENT_PARAM,
    getParameterByName,
    isAgentAndAgreementSpecified
} from '../../../../services/partners/partnersService';

export interface DispatchToProps {
    fetchCalculationData: Function;
    fetchUpdateCalculationData: Function;
    fetchBuyCalculationData: Function;
    fetchTemplateData: Function;
    updateCalculationData: Function;
}

interface Props {}

interface StateToProps {
    firstStepForm: any;
    calculationData: any;
    buyingInformationForm: any;
    detailsPanelForm: any;
}

interface State {
    step: number;
    chosenInsurancePrice: number;
    pluspaketCoveragesPrice: number;
    tillagsCoveragesPrice: number;
    tillagsHyrbilPrice: number;
    tillagsAllriskPrice: number;
}

class CompanyCarFlow extends React.Component<
    Props & DispatchToProps & StateToProps,
    State
> {
    componentWillMount(): void {
        if (isAgentAndAgreementSpecified()) {
            this.props.fetchTemplateData(
                4003,
                parseInt(getParameterByName(AGREEMENT_PARAM))
            );
        } else {
            this.props.fetchTemplateData(4003, 670);
        }
    }

    componentDidMount(): void {
        let cpr = window.sessionStorage.getItem('company_car_cpr');
        let regPlate = window.sessionStorage.getItem('company_car_reg_plate');
        if (cpr && regPlate) {
            cpr = cpr.replace(/-/g, '');
            this.calculationData.regPlate = regPlate.toUpperCase();
            this.calculationData.cpr = cpr;
            if (
                (cpr.length === 10 ||
                    (cpr.length === 12 && ageResolver(cpr) >= 18)) &&
                (Personnummer.valid(cpr) || cin(cpr).isValid) &&
                regPlate.length === 6
            ) {
                let intervalUtag = setInterval(() => {
                    //@ts-ignore
                    if (window.utag) {
                        invokeUtagData(
                            createUtagViewData(
                                StatsDataEnum.APPLICATION_NAME,
                                'company-car',
                                resolvePartnerForStats(),
                                window.location.pathname +
                                    'company-car/' +
                                    StatsDataEnum.CALCULATION,
                                StatsDataEnum.PAGE_TITLE,
                                'tjanstebilforsakring',
                                StatsDataEnum.CALCULATION
                            )
                        );
                        clearInterval(intervalUtag);
                    }
                }, 500);

                this.props.fetchCalculationData(
                    this.calculationData,
                    this.goToSecondStep
                );
            }
        }
    }

    state = {
        step: 1,
        chosenInsurancePrice: 0,
        pluspaketCoveragesPrice: 0,
        tillagsCoveragesPrice: 0,
        tillagsHyrbilPrice: 0,
        tillagsAllriskPrice: 0
    };

    calculationData: CompanyCarCalculationData = {
        cpr: '',
        regPlate: '',
        yearlyKm: 15,
        riskBasicNumber: 101,
        riskProductNumber: 48,
        agreementProduct: 670,
        productNumber: '4003',
        vagnskadaSelfrisk: '3',
        pluspaketCoverages: false,
        tillagsCoverages: false,
        tillagsHyrbilCoverage: true,
        tillagsAllriskCoverage: true,
        coveragePacketSelected: 1,
        startDate: new Date().toISOString().slice(0, 10),
        paymentTerm: PaymentTerms.MONTHLY,
        mailingChannel: MailingChannel.EMAIL,
        agentNumber: null
    };

    nextStep = () => {
        this.setState({
            step: this.state.step + 1
        });
    };

    previousStep = () => {
        window.scrollTo(0, 0);
        document.location.reload();
        this.setState({
            step: this.state.step - 1
        });
    };

    goToSecondStep = () => {
        this.props.calculationData.calculatedData.calculation.tillagsHyrbilCoverage = true;
        this.props.calculationData.calculatedData.calculation.tillagsAllriskCoverage = true;

        this.nextStep();
        this.resolveCoverageRecommendation(
            this.props.calculationData.calculatedData.calculationOut
        );
    };

    resolveCoverageRecommendation = (calculationOut: CalculationOut) => {
        if (calculationOut.trafikRemark) {
            this.calculationData.coveragePacketSelected = 0;
        } else if (calculationOut.halvRemark) {
            this.calculationData.coveragePacketSelected = 1;
        } else if (calculationOut.helRemark) {
            this.calculationData.coveragePacketSelected = 2;
        }
        if (
            (calculationOut.directInport === 'IMPORT' ||
                calculationOut.directInport === 'TULL') &&
            calculationOut.vehicleAge < 3
        ) {
            this.calculationData.coveragePacketSelected = 2;
        }
    };

    calculatePriceWithDefaultData = () => {
        this.calculationData.cpr = this.props.firstStepForm.values.cpr.replace(
            /-/g,
            ''
        );
        this.calculationData.regPlate = this.props.firstStepForm.values.regPlate;
        this.updateCalculationDataIfAllowedAgentAndAgreementSpecified();
        this.props.fetchCalculationData(
            this.calculationData,
            this.goToSecondStep
        );
    };

    insuranceSelectionHandling = (
        coveragePacketSelected: number,
        price: number
    ) => {
        let calculationOut: CalculationOut = this.props.calculationData
            .calculatedData.calculationOut;
        this.calculationData.pluspaketCoverages = false;
        this.calculationData.tillagsCoverages = false;
        this.calculationData.tillagsHyrbilCoverage = true;
        this.calculationData.tillagsAllriskCoverage = true;
        this.calculationData.coveragePacketSelected = coveragePacketSelected;
        this.setState({
            chosenInsurancePrice: price
        });
        this.props.updateCalculationData(this.calculationData, calculationOut);
    };

    plusPackageBuyHandling = (price: number) => {
        let calculationOut: CalculationOut = this.props.calculationData
            .calculatedData.calculationOut;
        this.calculationData.pluspaketCoverages = !this.calculationData
            .pluspaketCoverages;
        this.setState({
            pluspaketCoveragesPrice: price
        });
        this.props.updateCalculationData(this.calculationData, calculationOut);
    };

    tillagsBuyHandling = (cover: number) => {
        let calculationOut: CalculationOut = this.props.calculationData
            .calculatedData.calculationOut;

        switch (cover) {
            case TillagsCoveragesIds.HYRBILL:
                this.calculationData.tillagsHyrbilCoverage = !this
                    .calculationData.tillagsHyrbilCoverage;
                break;
            case TillagsCoveragesIds.ALLRISK:
                this.calculationData.tillagsAllriskCoverage = !this
                    .calculationData.tillagsAllriskCoverage;
                break;
            default:
                this.calculationData.tillagsCoverages = !this.calculationData
                    .tillagsCoverages;
        }

        this.props.updateCalculationData(this.calculationData, calculationOut);
    };

    mileageChangeHandling = async (event, onChange: Function) => {
        await onChange(event);
        let calculationOut: CalculationOut = this.props.calculationData
            .calculatedData.calculationOut;
        this.calculationData.yearlyKm = this.props.detailsPanelForm.values.yearlyKm;
        this.updateCalculationDataIfAllowedAgentAndAgreementSpecified();
        this.props.fetchUpdateCalculationData(
            this.calculationData,
            calculationOut
        );
    };

    carDamageChangeHandling = async (event, onChange: Function) => {
        await onChange(event);
        let calculationOut: CalculationOut = this.props.calculationData
            .calculatedData.calculationOut;
        this.calculationData.vagnskadaSelfrisk = this.props.detailsPanelForm.values.vagnskadaSelfrisk;
        this.updateCalculationDataIfAllowedAgentAndAgreementSpecified();
        this.props.fetchUpdateCalculationData(
            this.calculationData,
            calculationOut
        );
    };

    paymentTermChangeHandling = async (event, onChange: Function) => {
        await onChange(event);
        let calculationOut: CalculationOut = this.props.calculationData
            .calculatedData.calculationOut;
        this.calculationData.paymentTerm = Number(
            this.props.buyingInformationForm.values.paymentTerm
        );

        this.updateCalculationDataIfAllowedAgentAndAgreementSpecified();
        this.props.fetchUpdateCalculationData(
            this.calculationData,
            calculationOut
        );
    };

    mailingChannelChangeHandling = async (event, onChange: Function) => {
        await onChange(event);
        let calculationOut: CalculationOut = this.props.calculationData
            .calculatedData.calculationOut;
        this.calculationData.mailingChannel = this.props.buyingInformationForm.values.mailingChannel;
        this.updateCalculationDataIfAllowedAgentAndAgreementSpecified();
        this.props.fetchUpdateCalculationData(
            this.calculationData,
            calculationOut
        );
    };

    setPricesForSummaryPage = (
        insurancePrice,
        plusPackagePrice,
        tillagsPrice
    ) => {
        this.setState({
            chosenInsurancePrice: insurancePrice,
            pluspaketCoveragesPrice: plusPackagePrice,
            tillagsCoveragesPrice: tillagsPrice
        });
    };

    handleBuy = () => {
        let calculationOut: CalculationOut = this.props.calculationData
            .calculatedData.calculationOut;
        this.calculationData.startDate =
            this.props.buyingInformationForm.values &&
            this.props.buyingInformationForm.values.startDate
                ? moment(this.props.buyingInformationForm.values.startDate)
                      .format('YYYY-MM-DD')
                      .toString()
                : this.calculationData.startDate;
        this.calculationData.customerPhone = this.props.buyingInformationForm.values.telephone.replace(
            /-|\s/g,
            ''
        );
        this.calculationData.customerEmail = this.props.buyingInformationForm.values.email;

        this.updateCalculationDataIfAllowedAgentAndAgreementSpecified();
        this.props.fetchBuyCalculationData(
            this.calculationData,
            calculationOut,
            this.nextStep
        );
    };

    updateCalculationDataIfAllowedAgentAndAgreementSpecified = () => {
        if (isAgentAndAgreementSpecified()) {
            this.calculationData = {
                ...this.calculationData,
                ...{
                    agentNumber: parseInt(getParameterByName(AGENT_PARAM)),
                    agreementProduct: parseInt(
                        getParameterByName(AGREEMENT_PARAM)
                    )
                }
            };
        }
    };

    prepareDataForStats = () => {
        return {
            order_id: this.props.calculationData.calculatedData.calculationOut
                .policyNumber,
            order_total: resolvePriceForPaymentTerm(
                calculatePrice(
                    this.calculationData.pluspaketCoverages,
                    this.state.chosenInsurancePrice,
                    this.state.pluspaketCoveragesPrice,
                    this.calculationData.tillagsCoverages,
                    this.state.tillagsCoveragesPrice
                ),
                this.calculationData.paymentTerm,
                PaymentTerms.YEAR
            ),
            product_unit_price: resolvePriceForPaymentTerm(
                calculatePrice(
                    this.calculationData.pluspaketCoverages,
                    this.state.chosenInsurancePrice,
                    this.state.pluspaketCoveragesPrice,
                    this.calculationData.tillagsCoverages,
                    this.state.tillagsCoveragesPrice
                ),
                this.calculationData.paymentTerm,
                PaymentTerms.YEAR
            )
        };
    };

    prepareSummaryData = () => [
        {
            header: getText('webshopsweden.common.summaryPage.overview'),
            values: [
                {
                    key: getText(
                        'webshopsweden.common.summaryPage.overview.policyHolder'
                    ),
                    value: this.props.calculationData.calculatedData
                        .calculationOut.customerName
                },
                {
                    key: getText(
                        'webshopsweden.common.summaryPage.overview.paymentType'
                    ),
                    value: resolvePaymentTerm(this.calculationData.paymentTerm)
                }
            ]
        },
        {
            header: getText('webshopsweden.common.summaryPage.insurance'),
            values: [
                {
                    key: this.props.calculationData.calculatedData
                        .calculationOut.vehicleName,
                    value: this.calculationData.regPlate
                },
                {
                    key: getText(
                        'webshopsweden.common.summaryPage.insurance.policyNumber'
                    ),
                    value: this.props.calculationData.calculatedData
                        .calculationOut.policyNumber
                },
                {
                    key: getText(
                        'webshopsweden.common.buyingInformation.startDate'
                    ),
                    value: this.calculationData.startDate
                },
                {
                    key: getText('webshopsweden.products.car.mileage'),
                    value: resolveMileage(this.calculationData.yearlyKm)
                },
                {
                    key: getText(
                        'webshopsweden.common.summaryPage.insurance.boughtInsurance'
                    ),
                    value: resolveChosenInsuranceName(
                        this.props.calculationData.calculatedData.calculation
                            .coveragePacketSelected,
                        this.calculationData.pluspaketCoverages,
                        this.calculationData.tillagsCoverages
                    )
                }
            ]
        },
        {
            header: getText('webshopsweden.common.summaryPage.yourPrice'),
            values: [
                {
                    key: getText(
                        'webshopsweden.common.summaryPage.yourPrice.yearlyPrice'
                    ),
                    value:
                        numberWithSpaces(
                            resolvePriceForPaymentTerm(
                                calculatePrice(
                                    this.calculationData.pluspaketCoverages,
                                    this.state.chosenInsurancePrice,
                                    this.state.pluspaketCoveragesPrice,
                                    this.calculationData.tillagsCoverages,
                                    this.state.tillagsCoveragesPrice
                                ),
                                this.calculationData.paymentTerm,
                                PaymentTerms.YEAR
                            )
                        ) + ' kr'
                },
                {
                    key: getText(
                        'webshopsweden.common.summaryPage.yourPrice.monthPrice'
                    ),
                    value:
                        numberWithSpaces(
                            resolvePriceForPaymentTerm(
                                calculatePrice(
                                    this.calculationData.pluspaketCoverages,
                                    this.state.chosenInsurancePrice,
                                    this.state.pluspaketCoveragesPrice,
                                    this.calculationData.tillagsCoverages,
                                    this.state.tillagsCoveragesPrice
                                ),
                                this.calculationData.paymentTerm,
                                PaymentTerms.MONTHLY
                            )
                        ) + ' kr'
                }
            ]
        }
    ];

    renderCompanyCar() {
        const { step } = this.state;
        switch (step) {
            case 1:
                return (
                    <FirstStep
                        onSubmit={this.calculatePriceWithDefaultData}
                        initialValues={{
                            regPlate:
                                window.sessionStorage.getItem(
                                    'company_car_reg_plate'
                                ) != null
                                    ? window.sessionStorage
                                          .getItem('company_car_reg_plate')
                                          .toUpperCase()
                                    : null,
                            cpr: window.sessionStorage.getItem(
                                'company_car_cpr'
                            )
                        }}
                    />
                );
            case 2:
                return (
                    <SecondStep
                        insuranceSelectionHandling={
                            this.insuranceSelectionHandling
                        }
                        plusPackageBuyHandling={this.plusPackageBuyHandling}
                        plusPackageSelected={
                            this.calculationData.pluspaketCoverages
                        }
                        tillagsBuyHandling={this.tillagsBuyHandling}
                        tillagsSelected={this.calculationData.tillagsCoverages}
                        tillagsHyrbilSelected={
                            this.calculationData.tillagsHyrbilCoverage
                        }
                        tillagsAllriskSelected={
                            this.calculationData.tillagsAllriskCoverage
                        }
                        mileageChangeHandling={this.mileageChangeHandling}
                        carDamageChangeHandling={this.carDamageChangeHandling}
                        paymentTermChangeHandling={
                            this.paymentTermChangeHandling
                        }
                        onSubmit={this.handleBuy}
                        setPricesForSummaryPage={this.setPricesForSummaryPage}
                        mailingChannelChangeHandling={
                            this.mailingChannelChangeHandling
                        }
                        goBack={this.previousStep}
                    />
                );
            case 3:
                return (
                    <CompanyCarSummaryStep
                        sectionsProvider={this.prepareSummaryData}
                        statsData={this.prepareDataForStats()}
                    />
                );
            default:
                return (
                    <FirstStep onSubmit={this.calculatePriceWithDefaultData} />
                );
        }
    }

    render() {
        return this.renderCompanyCar();
    }
}

const mapStateToProps = state => ({
    firstStepForm: state.form.firstStep,
    calculationData: state.calculationData,
    detailsPanelForm: state.form.detailsPanel,
    buyingInformationForm: state.form.buyingInformation
});

const mapDispatchToProps = {
    fetchCalculationData,
    fetchUpdateCalculationData,
    fetchBuyCalculationData,
    fetchTemplateData,
    updateCalculationData
};

export default connect<{}, {}, any>(
    mapStateToProps,
    mapDispatchToProps
)(CompanyCarFlow);
